// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1epd7","load2":"Spinner_load2__SXJOY"};